import { z } from 'zod';


const updateAttendanceConceptBaseSchema = z.object({
  handlingId: z.union([
    z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().positive(),
    z.null(),
  ]),
  calculationFormulaId: z.union([
    z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().positive(),
    z.null(),
  ]),
  obtentionFormulaId: z.union([
    z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().positive(),
    z.null(),
  ]),
});

export const updateAttendanceConceptSchema = updateAttendanceConceptBaseSchema
  .refine((data) => data.handlingId !== null, {
    message: 'attendance:attendanceConcept.validation.handlingRequired',
    path: ['handlingId'],
  })
  .refine((data) => data.calculationFormulaId !== null, {
    message: 'attendance:attendanceConcept.validation.calculationFormulaRequired',
    path: ['calculationFormulaId'],
  })
  .refine((data) => data.obtentionFormulaId !== null, {
    message: 'attendance:attendanceConcept.validation.obtentionFormulaRequired',
    path: ['obtentionFormulaId'],
  });

export type UpdateAttendanceConceptFormData = z.infer<typeof updateAttendanceConceptSchema>;
